import PropTypes from 'prop-types'

const ButtonSizePropType = PropTypes.oneOf([
  'medium',
  'small',
  'small-tiny',
])

export default ButtonSizePropType
